import { useState } from 'react';
import StripeSubscribeModal from './settings/StripeSubscribeModal';

// Define your plans — priceId comes from your Stripe Dashboard
const PLANS = [
  {
    priceId: 'price_monthly_xxx',   // ← replace with real Stripe Price ID
    name: 'Pro',
    amount: 29,
    interval: 'month',
    features: ['Unlimited projects', 'Priority support', 'Analytics'],
  },
  {
    priceId: 'price_yearly_xxx',    // ← replace with real Stripe Price ID
    name: 'Pro (Annual)',
    amount: 290,
    interval: 'year',
    features: ['Everything in Pro', '2 months free', 'Early access'],
  },
];

// In a real app, get this from your auth context / session
const CURRENT_USER = { email: 'jane@example.com', name: 'Jane Smith' };

export default function PricingPage() {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const defaultItem = { enableInstaller: true, distance_unit: 'mile' }
  const [item, setItem] = useState(defaultItem);
  const [paypalPaymentModalOpen, setPaypalPaymentModalOpen] = useState(false);
  const [updateTimestamp, setUpdateTimestamp] = useState(0);
  const paymentCallback = (result, apiRes) => {
    if (result === "success") {
      if (apiRes && apiRes["device"]) {
        const newDevice = apiRes["device"];
        setItem({ ...item, credit: newDevice.credit });
      }
      //showToast("Paid successfully!")
    } else {
      alert("Paypal payment error!");
    }
  };


  const onClickPlan = (plan) => {
    setSelectedPlan(plan);
    setPaypalPaymentModalOpen(true);
  }

  const handleSuccess = ({ subscriptionId }) => {
    console.log('Subscription created:', subscriptionId);
    // 1. Update your local user state / context
    // 2. Redirect to dashboard or show success UI
    // 3. Optionally call your own API to record the subscription
  };

  return (
    <div style={{ maxWidth: 680, margin: '4rem auto', padding: '0 1.5rem' }}>
      <h1>Choose a plan</h1>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        Start with a 14-day free trial. Cancel anytime.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        {PLANS.map(plan => (
          <div
            key={plan.priceId}
            style={{
              border: '1px solid #e5e5e5',
              borderRadius: 12,
              padding: '1.5rem',
            }}
          >
            <h2 style={{ fontSize: 18, marginBottom: 4 }}>{plan.name}</h2>
            <p style={{ fontSize: 24, fontWeight: 700, marginBottom: '1rem' }}>
              ${plan.amount}
              <span style={{ fontSize: 14, fontWeight: 400, color: '#888' }}>
                {' '}/ {plan.interval}
              </span>
            </p>

            <ul style={{ listStyle: 'none', padding: 0, marginBottom: '1.25rem' }}>
              {plan.features.map(f => (
                <li key={f} style={{ fontSize: 14, color: '#444', marginBottom: 6 }}>
                  ✓ {f}
                </li>
              ))}
            </ul>

            <button
              onClick={() => onClickPlan(plan)}
              style={{
                width: '100%',
                padding: '10px',
                background: '#0F6E56',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Get started
            </button>
          </div>
        ))}
      </div>

      {/* Modal — renders outside the card grid, portal-style */}
      {/* <StripeSubscribeModal
        isOpen={!!selectedPlan}
        plan={selectedPlan ?? PLANS[0]}
        user={CURRENT_USER}
        onClose={() => setSelectedPlan(null)}
        onSuccess={handleSuccess}
      /> */}

      <>
        <StripeSubscribeModal
          open={paypalPaymentModalOpen}
          setOpen={setPaypalPaymentModalOpen}
          amount={1200}
          itemType={`deviceCredit`}
          item={item}
          setItem={setItem}
          updateTimestamp={updateTimestamp}
          setUpdateTimestamp={setUpdateTimestamp}
          callback={paymentCallback}
          user_type={`user`}
          user_id={1}
          user={{ email: "test@gmail.com", name: "test123" }}
        />
      </>
    </div>
  );
}
